import { Component, OnInit, QueryList } from '@angular/core';
import { TramitesService } from 'src/app/servicios/tramites.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { PublicService } from 'src/app/servicios/public/public.service';
import { FormGroup,FormBuilder } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-tramites-ciudadano',
  templateUrl: './tramites-ciudadano.component.html',
  styleUrls: ['./tramites-ciudadano.component.css']
})
export class TramitesCiudadanoComponent implements OnInit {
  public listado: any = [];
  public dtElements: QueryList<DataTableDirective>;
  public dtTrigger: Subject<any> = new Subject();
  public filtroTramite: FormGroup;
  public serve: string;
  public checklist: any;
  public TramitesFiltrados: any = [];
  public estamentos: any = [];
  public unidadOrganizativa: any = [];
  public facultades: any = [];
  public programas: any = [];
  public sw:any = 0;
  
  constructor(private TramiteService: TramitesService, private servi: PublicService, private form: FormBuilder) { 
    
     if(this.sw == 0){
      
      this.servi.getTiposTramites().subscribe(data=>{
        this.listado = data['listado'];
        this.sw=1;
      });
      
    }

    this.serve = this.servi.getServe();

    this.filtroTramite = this.form.group({
      estamentos: [''],
      unidades_organizativas: [''],
      facultades: [''],
      programas: [''],
    });

    this.servi.getBusquedaTramiteCiudadano()
      .subscribe(data => {

        this.estamentos = data['estamentos'];
        this.unidadOrganizativa = data['unidadOrganizativa'];
        this.facultades = data['facultades'];
        this.programas = data['programas'];

        this.dtTrigger.next();
      });

  }


  FiltrarTramites() {

    if (!this.filtroTramite.valid) {
      Swal.fire({
        type: 'error',
        title: 'Error',
        text: 'Verifique los datos e intente nuevamente',
        showConfirmButton: false,
        timer: 1500
      });
    } else {
      this.servi.getFiltrarTramites(this.filtroTramite.value)
        .subscribe(async data => {
          this.listado = data;
          this.rerender();
        });
    }
  }

 

  ngOnInit() {
  }

  limpiar() {
    this.filtroTramite.reset();
    this.rerender();
  }


  rerender(): void {
    this.dtElements.forEach((dtElement: DataTableDirective) => {
      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    });
  }

}
